import {
    UseQueryOptions,
    UseQueryResult,
    useQuery,
} from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';

export type Project = {
    id: number;
    name: string;
    inscriptionsCount: number;
};

const fetchProjects = async (): Promise<Project[]> => {
    const response = await RQAPICallWithData<Project[]>({
        endpoint: 'projects',
        method: 'GET',
    });

    return response.content.data || [];
};

/**
 * Return the list of projects or an empty array, along with the usual React-Query response.
 * Options are passed to the useQuery hook and can not override initialData
 *
 * @returns `{ projects, isLoading, error, isFetching, ... }`
 */
export const useGetProjects = (
    options?: Pick<UseQueryOptions, 'enabled' | 'staleTime'>,
): { projects: Project[] } & Omit<
    UseQueryResult<Project[], unknown>,
    'data'
> => {
    const { data, ...response } = useQuery<Project[]>({
        queryKey: ['projects'],
        queryFn: fetchProjects,
        ...options,
    });
    const projects = data ?? [];
    return { projects, ...response };
};
